import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { ITableLargeColumnConfig } from 'projects/common/src/app/interfaces/table/table-large-column-config';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { ExcelExportService } from 'projects/common/src/app/services/utils/excel-export.service';
import { excelExportDateFormat } from 'projects/common/src/app/services/utils/util.service';
import { IFilterConfig } from 'src/app/modules/core/interfaces/filter-config';
import { IOutputFilter } from 'src/app/modules/core/interfaces/output-filter';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { ILayoutConfig } from 'src/app/modules/layout/interfaces/layout-config';
import { LayoutConfigService } from 'src/app/modules/layout/services/layout-config.service';
import { IReportDownloadHistory } from '../../interfaces/report-download-history';
import { ReportDownloadHistoryService } from '../../services/report-download-history';

@Component({
  selector: 'app-report-download-history',
  templateUrl: './report-download-history.component.html',
  styleUrls: ['./report-download-history.component.scss'],
})
export class ReportDownloadHistoryComponent implements OnInit {
  public selectedFilters: IOutputFilter;
  public params: IOutputFilter;
  public tableConfig: ITableConfig;
  public tableData: IReportDownloadHistory[];
  public filterConfig: IFilterConfig;
  public btnSpinner: boolean;
  public disabledExcelBtn: boolean;

  constructor(
    private layoutConfigService: LayoutConfigService,
    private downloadHistoryService: ReportDownloadHistoryService,
    private tableService: TableConfigService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private _excelExportService: ExcelExportService,
    private cdr: ChangeDetectorRef,
  ) {
    this.filterConfig = {
      dates: { required: true },
      cleanButton: true,
    };
    this.tableData = [];
    this.disabledExcelBtn = false;
  }

  ngOnInit(): void {
    const config: ILayoutConfig = {
      title: 'reports',
      subtitle: 'report-download-history',
      imageKey: 'report',
      imageType: 'section',
    };

    this.layoutConfigService.setConfig(config);
    this.cdr.detectChanges();
  }

  /**
   * Function to get report data from received filters
   *
   * @param filters Filters selected to get data
   */
  public async getReportByFilters(selectedFilters: IOutputFilter): Promise<void> {
    this.filterConfig.isLoading = true;
    this.selectedFilters = selectedFilters;

    this.params = this.downloadHistoryService.setParams(selectedFilters);
    this.tableData = [];
    await this.downloadHistoryService
      .getReportDownloadHistoryReportData(this.params)
      .then((resp) => {
        for (const element of resp) {
          this.tableData.push({
            reportName: element.reportName ? element.reportName : null,
            userName: element.userName ? element.userName : null,
            downloadStartedAt: element.downloadStartedAt ? element.downloadStartedAt : null,
            downloadFinishedAt: element.downloadFinishedAt ? element.downloadFinishedAt : null,
            duration: element.duration,
          });
        }
      })
      .finally(() => {
        this.filterConfig.isLoading = false;
      });
    this.setTableConfig(this.tableData);
    const filters = {
      reports: 'report-download-history',
    };
    this.googleAnalyticsService.sendCustomEvent('filter', filters);
  }

  /**
   * set table config
   */
  public setTableConfig(tableData: any[]): void {
    const customLargeColumns: ITableLargeColumnConfig[] = [
      { field: 'reportName', isLargeColumn: true },
      { field: 'userName', isLargeColumn: true },
      { field: 'downloadStartedAt', isLargeColumn: true },
      { field: 'downloadFinishedAt', isLargeColumn: true },
      { field: 'duration', isLargeColumn: true },
    ];
    const headerParams: ITableHeaderParams = {
      data: tableData,
      customLargeColumns,
      sortables: true,
    };

    const datasetParams: ITableDataParams = {
      tableData,
      customLargeColumns,
      dateConfig: [
        { field: 'downloadStartedAt', format: 'date-time' },
        { field: 'downloadFinishedAt', format: 'date-time' },
      ],
    };

    const { header, dataset } = this.tableService.setTableMainConfig(headerParams, datasetParams);

    this.tableConfig = { header, dataset };
  }

  /**
   * Function to download report
   */
  public async downloadReport(): Promise<void> {
    const selectRangeDate = {
      startDate: excelExportDateFormat(this.selectedFilters.startDate),
      endDate: excelExportDateFormat(this.selectedFilters.endDate),
    };

    this.btnSpinner = true;
    this.disabledExcelBtn = true;
    this.downloadHistoryService.getReportDownloadHistoryReportExcel(this.selectedFilters).subscribe({
      next: (response) => {
        this._excelExportService.exportAsExcel(response, 'report-download-history', selectRangeDate, null, false);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastSuccess();
      },
      error: (error) => {
        console.error(error);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastError();
      },
    });
  }
}
